import { SEOHead } from '@/components/@next/SEOHead';
import { ContactUs as ContactUsPage } from '../containers/contactUsPage/contactUs';
import NextApp from '../NextApp';

export default function ContactUs() {
  return (
    <NextApp>
      <SEOHead
        title="Contact Us"
        description="Please keep in touch with us using the provided contact methods."
      ></SEOHead>
      <ContactUsPage />
    </NextApp>
  );
}
